import React from 'react';
const CopiriLoader = (props) => {
	return (
		<div className="loader-main">
	       <div className="loader"></div>
	    </div>
	)
}
export default CopiriLoader;